import {
  Box,
  Grid,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import React from 'react';
import {
  AppFormikSelect,
  AppFormikTextField,
} from 'shared/components/AppComponents';

const PaperFormSecurityCompliance: React.FC<PaperFormCharacteristicProps> = (
  props
) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { purpose } = props;
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box className="paper-form-content">
      <Paper variant="outlined">
        <Typography variant="h6">Security & Compliance</Typography>
        <Box className="paper-form-input-content">
          <Grid spacing={4} container className="paper-form-label-input-grid">
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                outerLabel
                label="Access Controls"
                placeholder="Describe access controls"
                name="accessControl"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                outerLabel
                label="Encryption"
                placeholder="Encryption Methods"
                name="encryption"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                outerLabel
                label="Retention Policy"
                placeholder="Data retention policy"
                name="retentionpolicy"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                outerLabel
                label="Sharing Restrictions"
                placeholder="Sharing Restrictions"
                name="sharingrestriction"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Stack
                direction={match ? 'column' : 'row'}
                spacing={2}
                className="compliance-data"
              >
                <Box width="100%">
                  <AppFormikSelect
                    name="compliancetags"
                    className="rework-selection"
                    notched={false}
                    labelId="fix-selection-label"
                    testid="solicitor-dropdown"
                    MenuProps={{
                      className: 'menu-fix-selection single-fix-rework',
                    }}
                    outerLabel
                    placeholder="Add Tag"
                    notEmphasized
                    notSelectablePlaceholder
                    label="Compliance Tags"
                    items={[
                      'CCPA',
                      'HIPAA',
                      'SOX',
                      'FERPA',
                      'PCI-DSS',
                      'ISO27001',
                      'Other',
                    ]}
                    multiple
                  />
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default PaperFormSecurityCompliance;
